<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30" id="offerSkuList">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class="wd-lg-300">{{ $t("stockout.SKU信息") }}</th>
            <th class="wd-lg-150">{{ $t("stockout.供应商信息") }}</th>
            <th class="wd-lg-150">{{ $t("stockout.相关采购单") }}</th>
            <th class="wd-lg-100">{{ $t("stockout.状态") }}</th>
            <th class="wd-lg-150">{{ $t("stockout.预计到货时间") }}</th>
            <th class="wd-lg-150">{{ $t("stockout.登记相关时间") }}</th>
            <th class="wd-lg-100">{{ $t("stockout.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id">
            <td class="valign-middle tx-12 pd-b-30">
              <div class="media d-block d-sm-flex align-items-center">
                <a
                  class="p-img-wrap"
                  href="javascript:;"
                  v-lazy:background-image="item.imgUrl"
                  :style="{
                    backgroundImage:
                      'url(' +
                      (item.imgUrl ? item.imgUrl : 'img/none-img.png') +
                      ')',
                    backgroundSize: scale[index].scale ? 'auto 100%' : '100%',
                  }"
                  @click="preview(item.imgUrl, item.productName)"
                >
                </a>
                <div
                  class="
                    media-body
                    align-self-center
                    mg-t-10 mg-b-10
                    tx-12
                    pos-relative
                  "
                >
                  <p class="mg-b-5 tx-ellipsis2">
                    {{ $t("stockout.商品: ") }}
                    <span class="tx-white">{{ item.productName }}</span>
                  </p>
                  <p class="mg-b-5">
                    {{ $t("stockout.属性: ") }}
                    <span class="tx-white">{{ item.propertyValue }}</span>
                  </p>
                  <p class="mg-b-5">
                    SKU:
                    <span class="tx-white">{{ item.sku }}</span>
                    <a
                      class="to-clipboard"
                      href="javascript:;"
                      :data-clipboard-text="item.sku"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p v-if="item.distributorSku" class="mg-b-0">
                    {{ $t("stockout.客户SKU: ") }}
                    <span class="tx-white">{{ item.distributorSku }}</span>
                    <a
                      class="to-clipboard"
                      href="javascript:;"
                      :data-clipboard-text="item.sku"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p
                    class="
                      mg-b-0
                      d-flex
                      align-items-center
                      pos-absolute
                      tx-ellipsis1
                    "
                    v-if="item.remark.length > 0"
                    style="width: 300%; bottom: -24px"
                  >
                    {{ $t("stockout.最新日志：") }}
                    <span
                      class="d-inline-block tx-ellipsis1 mg-r-10 tx-orange"
                      >{{ item.remark[0] }}</span
                    >
                    <a
                      class="tx-info"
                      href="javascript:;"
                      @click="openLog(index)"
                      >{{ $t("stockout.更多") }}</a
                    >
                  </p>
                </div>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0">
                <p class="mg-b-5">
                  {{ $t("stockout.经销商: ") }}
                  <span
                    class="d-inline-block tx-white tx-ellipsis1"
                    style="max-width: 150px"
                    >{{
                      item.distributorName ? item.distributorName : "---"
                    }}</span
                  >
                  <a
                    v-if="item.distributorName"
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="item.distributorName"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0">
                <p class="mg-b-5">
                  {{ $t("stockout.单号: ") }}
                  <span class="tx-white">{{
                    item.orderCode ? item.orderCode : "---"
                  }}</span>
                  <a
                    v-if="item.orderCode"
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="item.orderCode"
                  >
                    <i class="icon ion-clipboard"></i>
                  </a>
                </p>
                <p class="mg-b-5">
                  {{ $t("stockout.子账号: ")
                  }}<span class="tx-white">{{
                    item.subUserName ? item.subUserName : "---"
                  }}</span>
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0">
                <p v-if="item.status > 0" class="mg-b-5">
                  {{ $t("stockout.状态：") }}
                  <span v-if="item.status == 1" class="tx-warning">{{
                    $t(statusArr[item.status])
                  }}</span>
                  <span v-if="item.status == 2" class="tx-success">{{
                    $t(statusArr[item.status])
                  }}</span>
                  <span v-if="item.status == 3" class="tx-primary">{{
                    $t(statusArr[item.status])
                  }}</span>
                  <span v-if="item.status == 4" class="tx-gray-600">{{
                    $t(statusArr[item.status])
                  }}</span>
                </p>
                <p v-if="item.type > 0" class="mg-b-5">
                  {{ $t("stockout.登记类型：") }}
                  <span class="tx-white">{{ $t(stockType[item.type]) }}</span>
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="tx-ellipsis2 mg-b-0 tx-white">
                <p class="mg-b-5 tx-ellipsis2">
                  {{
                    item.timeExpectedArrival
                      ? timeFormat_1(item.timeExpectedArrival)
                      : "---"
                  }}
                </p>
                <p class="mg-b-5 tx-ellipsis2" v-if="item.timeExpectedArrival">
                  <span v-if="item.status == 3">
                    <span
                      v-if="
                        diffTimeFinish(
                          item.timeExpectedArrival,
                          item.timeFinished
                        ) > 0
                      "
                      class="tx-danger"
                    >
                      ({{ $t("stockout.实际超出")
                      }}{{
                        diffTimeFinish(
                          item.timeExpectedArrival,
                          item.timeFinished
                        )
                      }}{{ $t("stockout.天") }})
                    </span>
                    <span
                      v-if="
                        diffTimeFinish(
                          item.timeExpectedArrival,
                          item.timeFinished
                        ) == 0
                      "
                      class="tx-white"
                    >
                      {{ $t("stockout.(实际准时到货)") }}
                    </span>
                    <span
                      v-if="
                        diffTimeFinish(
                          item.timeExpectedArrival,
                          item.timeFinished
                        ) < 0
                      "
                      class="tx-success"
                    >
                      ({{ $t("stockout.实际提前")
                      }}{{
                        diffTimeFinish(
                          item.timeExpectedArrival,
                          item.timeFinished
                        ) * -1
                      }}{{ $t("stockout.天") }})
                    </span>
                  </span>
                  <span v-else>
                    <span
                      v-if="diffTime(item.timeExpectedArrival) > 0"
                      class="tx-danger"
                    >
                      ({{ $t("stockout.已超过")
                      }}{{ diffTime(item.timeExpectedArrival)
                      }}{{ $t("stockout.天") }})
                    </span>
                    <span v-if="diffTime(item.timeExpectedArrival) <= 0">
                      ({{ $t("stockout.还剩")
                      }}{{ diffTime(item.timeExpectedArrival) * -1 + 1
                      }}{{ $t("stockout.天") }})
                    </span>
                  </span>
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div class="mg-b-0">
                <p class="mg-b-5">
                  {{ $t("stockout.登记时间: ")
                  }}<span class="tx-white">{{
                    item.timeCreated ? item.timeCreated : "---"
                  }}</span>
                </p>
                <p class="mg-b-5">
                  {{ $t("stockout.确认时间: ")
                  }}<span class="tx-white">{{
                    item.timeConfirmed ? item.timeConfirmed : "---"
                  }}</span>
                </p>
                <p class="mg-b-0">
                  {{ $t("stockout.完成时间: ")
                  }}<span class="tx-white">{{
                    item.timeFinished ? item.timeFinished : "---"
                  }}</span>
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12 pd-b-30">
              <div v-if="item.status == 1" class="tx-ellipsis2 mg-b-0 tx-white">
                <p class="mg-b-5 tx-ellipsis2">
                  <a
                    href="javascript:;"
                    class="tx-info"
                    @click="confirmDate(item)"
                    >{{ $t("stockout.确认到货日期") }}</a
                  >
                </p>
              </div>
              <div
                class="tx-ellipsis2 mg-b-0 tx-white"
                v-if="
                  item.status != 4 &&
                  isSysRights('OutOfStockList.addRemarkBySupplier')
                "
              >
                <p class="mg-b-5 tx-ellipsis2">
                  <a
                    href="javascript:;"
                    class="tx-info"
                    @click="openEdit(index)"
                    >{{ $t("stockout.填写备注") }}</a
                  >
                </p>
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="7">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("stockout.请选择时间类型") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
      scale: [],
      statusArr: arrDict.stockoutStatus,
      stockType: arrDict.stockType,
    };
  },
  watch: {
    items: {
      handler: function () {
        this.imgScale();
      },
      deep: true,
    },
  },
  computed: {},
  updated() {},
  methods: {
    confirmDate(item) {
      this.$emit('confirmDate', item)
    },
    preview(img, text) {
      this.$store.commit("setImgItem", [
        {
          img,
          text,
        },
      ]);
      this.$parent.loading = true;
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        if (viewer.images.length) viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    time(i) {
      let receiveTime = moment(this.items[i].timeExpectedArrival, "YYYY-MM-DD");
      let finishTime = moment(this.items[i].timeConfirmed, "YYYY-MM-DD");
      return Number(finishTime.diff(receiveTime, "days"));
      let today = moment();
    },
    diffTime(time) {
      let receiveTime = moment(time, "YYYY-MM-DD");
      let today = moment();
      return Number(today.diff(receiveTime, "days"));
    },
    diffTimeFinish(rTime, fTime) {
      let receiveTime = moment(rTime, "YYYY-MM-DD");
      let finishTime = moment(fTime, "YYYY-MM-DD");
      return Number(finishTime.diff(receiveTime, "days"));
    },
    openLog(i) {
      this.$emit("openLog", i);
    },
    openEdit(i) {
      this.$emit("openEdit", i);
    },
    openCancel(i) {
      this.$emit("openCancel", i);
    },
    imgScale() {
      this.scale = [];
      let vm = this;
      for (let i = 0; i < this.items.length; i++) {
        this.scale.push({ scale: false, sub: [] });
        if (this.items[i].imgUrl) {
          let img = new Image();
          img.src = this.items[i].imgUrl;
          img.onload = function () {
            if (img.width > img.height) {
              vm.$set(vm.scale[i], "scale", true);
            }
          };
        }
      }
    },
    timeFormat_1(val) {
      return moment(val, "YYYY-MM-DD h:mm:ss").format("YYYY-MM-DD");
    },
  },
};
</script>
<style scoped="scoped">
.table td.valign-middle,
.table th.valign-middle {
  padding-bottom: 20px;
}
</style>

